import {Injectable} from '@angular/core';
import {CustomErrorService} from '../../core/api/custom-error.service';

@Injectable({
  providedIn: 'root'
})
export class CustomErrorSharedService implements CustomErrorService {
  constructor() {
  }

  parse(init: {code?: number, message?: string, globalHandler?: boolean}): {code: number, message: string, globalHandler: boolean} {
    return {
      code: init.code || 0,
      message: init.message || 'Servizio non disponibile',
      globalHandler: init.globalHandler
    };
  }
}
